//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { store } from "@/observable/store"
import userInfoToast from '@/components/toast/userInfo'
import  { couponReceive } from '@/model/trader/orderService'
import PlanDetailsToast from '@/components/planDetailsToast'
import MipLightbox from '@/components/clinicToast/mipLightbox'

export default {
    name: "quota",
    data(){
        return {
          qqMusic:true,
          templateFlag:'zh_tw',
          timer:null,
          frequency:1,
          tel:'400-025-2560',
          foodBtn:true,
          scrollHand:'',
          bodyHe:''

        }
    },
    props: {
      homeImage:{
        type: String,
        default(){ return ''}
      },
      homeButton:{
        type: String,
        default(){ return ''}
      },
      serviceImage:{
        type: String,
        default(){ return ''}
      },
      organizationImage:{
        type: String,
        default(){ return ''}
      },
      procedureImage:{
        type: String,
        default(){ return ''}
      },
      submitButton:{
        type: String,
        default(){ return ''}
      },
    },
    components:{
        userInfoToast,
        PlanDetailsToast,
        MipLightbox
    },
    computed: {
        uid(){
              return store.uid
        },
        syToken(){
            return store.syToken
        },
        loginPhone(){
            return store.phone
        },
    },
    watch: {
      scrollHand(val){
        if((this.bodyHe-60)>val){
          this.foodBtn = true;
        }else{
          this.foodBtn = false;
        }
      },
    },
    created(){
       this.STATISTICS('load','sybao_ins_product_info_page')
      if(this.$route.query.templateFlag){
        this.templateFlag = this.$route.query.templateFlag;
      }
    },
    mounted() {
      this.bodyHe = document.body.clientHeight;
      window.addEventListener('scroll', this.handleScroll)

      this.timer =  setInterval(()=>{
        let time = this.frequency *3;
        this.STATISTICS('click','sybao_ins_product_info:stay_time_sys',{'stay_time':time+'s'})
        if(time == 60 || time - 60 > 0 ){
          clearInterval(this.timer)
        }
        this.frequency = this.frequency +1
      },3000)
      this.addTouch()
    },
    beforeDestroy() {
      this.removeTouch();
    },
    methods:{
      creadInfo(){
        let top = document.getElementById('infoId').offsetTop
          setTimeout(function(){
              scrollTo(0,top+150)
          },100)
        this.$parent.creadInfo()
      },
      handleScroll(){
        this.scrollHand = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      },
      telPhne(){
        this.openCall(this.tel)
      },
      hostList(){
          this.$refs.mipLightbox.showToast();
          this.STATISTICS('click','sybao_ins_proinfo_allclinic_click')
      },  
      plan(){
        this.STATISTICS('click','sybao_ins_proinfo_ensuredetail_click')
        this.$refs.planDetails.showToast()
      },
      handler(ev){
          // 滑动开始事件埋点
          this.STATISTICS('click','sybao_ins_product_info_slip')
      },
      addTouch(){
          document.body.addEventListener('touchstart', this.handler);
      },
      removeTouch(){
          document.body.removeEventListener('touchstart', this.handler);
          clearInterval(this.timer)
      },
    }
}
